import React from 'react';
import { PieChart, Pie, Cell, Legend } from 'recharts';

const COLORS = {
  orange: 'hsl(var(--chart-3))',
  blue: 'hsl(var(--chart-2))',
  green: 'hsl(var(--chart-1))',
  purple: 'hsl(var(--chart-4))',
  red: 'hsl(var(--chart-5))',
  mint: 'hsl(var(--chart-6))',
  turqoise: 'hsl(var(--chart-7))',
  black: '',
};
// const otherColors = [
//   'hsl(var(--chart-3))',
//   'hsl(var(--chart-2))',
//   'hsl(var(--chart-1))',
//   'hsl(var(--chart-4))',
//   'hsl(var(--chart-5))',
//   'hsl(var(--chart-6))',
//   'hsl(var(--chart-7))',
// ];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text fontSize={12} fontWeight="bold" x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
      {/* {`${(percent * 100).toFixed(0)}%`} */}
      {value}
    </text>
  );
};

export const StatsPieChart = ({ data }: { data: { name: string; value: number; color: string }[] }) => {
  return (
    <PieChart width={350} height={130}>
      <Pie
        data={data}
        cx="50%"
        cy="75%"
        startAngle={180}
        endAngle={0}
        paddingAngle={0}
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={90}
        innerRadius={60}
        fill="#8884d8"
        dataKey="value"
        cornerRadius={5}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[entry.color]} />
        ))}
      </Pie>
      <Legend
        layout="vertical"
        align="right"
        verticalAlign="top"
        height={24}
        iconSize={12}
        formatter={(value) => value[0].toUpperCase() + value.slice(1).replace(/_|-/g, ' ').toLowerCase()}
      />
    </PieChart>
  );
};
